import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './_guards/auth.guard';
import { ModalAuthGuard } from './_guards/modal-auth.guard';

import { HomeComponent } from './components/home/home.component';
import { MyEntriesComponent } from './components/my-entries/my-entries.component';
import { MyAccountComponent } from './components/my-account/my-account.component';
import { MyPeopleComponent } from './components/people/my-people/my-people.component';
import { MyHorsesComponent } from './components/horses/my-horses/my-horses.component';
import { LoginComponent } from './components/login/login.component';
import { LoggedInComponent } from './components/logged-in/logged-in.component';
import { OrganizerComponent } from './components/organizer/organizer.component';

import { CreateUserComponent } from './components/create-user/create-user.component';
import { SubmitEntriesComponent } from './components/submit-entries/submit-entries.component';
import { EntriesReceiptComponent } from './components/entries-receipt/entries-receipt.component';
import { SignDocumentComponent } from './components/sign-document/sign-document.component';
import { EntriesChequeReceiptComponent } from './components/entries-cheque-receipt/entries-cheque-receipt.component';

import { PrintEntryFormComponent } from './components/print-entry-form/print-entry-form.component';

import { AdoptIdentityLoginComponent } from './components/adopt-identity-login/adopt-identity-login.component';

import { SubmitSignatureComponent } from './components/submit-signature/submit-signature.component';
import { EditPayeeForHorseShowComponent } from './components/edit-payee-for-horse-show/edit-payee-for-horse-show.component';
import { EditPayeeCompleteComponent } from './components/edit-payee-for-horse-show/edit-payee-complete/edit-payee-complete.component';
import { LostPasswordComponent } from './components/lost-password/lost-password.component';
import { StorefrontComponent } from './components/storefront/storefront.component';
import { StorefrontReceiptComponent } from './components/storefront/storefront-receipt/storefront-receipt.component';
import { AccountStatementListComponent } from './components/account-statement-list/account-statement-list.component';
import { ViewAccountStatementComponent } from './components/account-statement-list/view-account-statement/view-account-statement.component';
import { EnterHorseShowLandingComponent } from './components/enter-horse-show-landing/enter-horse-show-landing.component';
import { DeclarationsLandingComponent } from './components/declarations-landing/declarations-landing.component';
import { UpdatePasswordComponent } from './components/update-password/update-password.component';
import { EntriesReceiptWithoutPaymentComponent } from './components/entries-receipt-without-payment/entries-receipt-without-payment.component';
import { AgreementAssentComponent } from './components/agreement-assent/agreement-assent.component';

const routes: Routes = [
    { path: 'home', component: HomeComponent, canActivate: [AuthGuard]},
    { path: 'my-entries', component: MyEntriesComponent, canActivate: [AuthGuard]},
    { path: 'my-account', component: MyAccountComponent, canActivate: [AuthGuard]},  
    { path: 'my-account/evet', component: MyAccountComponent, canActivate: [AuthGuard]},  
    { path: 'my-people', component: MyPeopleComponent, canActivate: [AuthGuard]},  
    { path: 'my-horses', component: MyHorsesComponent, canActivate: [AuthGuard]}, 
    { path: 'enter-horse-show-landing/:horse_show_id', component: EnterHorseShowLandingComponent, canActivate: [ModalAuthGuard]},
    { path: 'declarations-landing/:horse_show_id', component: DeclarationsLandingComponent, canActivate: [ModalAuthGuard]},
    { path: 'organizer-information/:id', component: OrganizerComponent},    
    { path: 'submit-signature/:id', component: SubmitSignatureComponent},
    { path: 'submit-document-signature/:id', component: SignDocumentComponent },    
    { path: 'submit-entries', component: SubmitEntriesComponent, canActivate: [AuthGuard] },
    { path: 'entries-receipt', component: EntriesReceiptComponent, canActivate: [AuthGuard] },    
    { path: 'entries-cheque-receipt', component: EntriesChequeReceiptComponent, canActivate: [AuthGuard] },    
    { path: 'entries-receipt-without-payment', component: EntriesReceiptWithoutPaymentComponent, canActivate: [AuthGuard] },    
    { path: 'print-entry/:entry_id', component: PrintEntryFormComponent, canActivate: [AuthGuard] },        
    { path: 'create-user', component: CreateUserComponent},
    { path: 'storefront/:horse_show_id/:category_number', component: StorefrontComponent },
    { path: 'store-payment-receipt/:order_id', component: StorefrontReceiptComponent },
  
    { path: 'login', component: LoginComponent},
    { path: 'review-agreements', component: AgreementAssentComponent },
    { path: 'lost-password', component: LostPasswordComponent},
    { path: 'lost-password/make-change/:token', component: UpdatePasswordComponent},
    { path: 'logged-in', component: LoggedInComponent, canActivate: [AuthGuard]},
    { path: 'adopt/identity/login', component: AdoptIdentityLoginComponent, canActivate: [AuthGuard]},
    { path: 'account-statements', component: AccountStatementListComponent, canActivate: [AuthGuard] },
    { path: 'account-statements/view/:entry_id', component: ViewAccountStatementComponent, canActivate: [AuthGuard] },
    { path: 'edit-payee-for-horse-show-entry/:horse_show_id/:entry_id/:payee_id', component: EditPayeeForHorseShowComponent},
    { path: 'edit-payee-for-horse-show-entry/:horse_show_id/:entry_id', component: EditPayeeForHorseShowComponent},
    { path: 'edit-payee-for-horse-show-entry/edit-payee-complete', component: EditPayeeCompleteComponent},
    { path: 'create-horse-show-entry', canActivate: [AuthGuard],
        loadChildren: () => import('./components/create-horse-show-entry/create-horse-show-entry.module').then(m => m.CreateHorseShowEntryModule)},
    { path: 'nominate-rider', canActivate: [AuthGuard],
        loadChildren: () => import('./components/nominate-rider/nominate-rider.module').then(m => m.NominateRiderModule)}, 
    { path: 'create-barn-account', canActivate: [AuthGuard],
        loadChildren: () => import('./components/create-barn-account/create-barn-account.module').then(m => m.CreateBarnAccountModule)
    },
    { path: 'invitations', 
        loadChildren: () => import('./components/invitations/invitations.module').then(m => m.InvitationsModule)
    },
    { path: 'tasks', 
        loadChildren: () => import('./components/tasks/tasks.module').then(m => m.TasksModule)
    },
    { path: 'check-out', 
        loadChildren: () => import('./components/check-out/check-out.module').then(m => m.CheckOutModule)
    },
    { path: 'sign-ups', 
        loadChildren: () => import('./components/sign-ups/sign-ups.module').then(m => m.SignUpsModule)
    },
    { path: 'declarations', canActivate: [AuthGuard],
        loadChildren: () => import('./components/declarations/declarations.module').then(m => m.DeclarationsModule)
    },
    { path: 'credentialing', canActivate: [AuthGuard],
        loadChildren: () => import('./components/credentialing/credentialing.module').then(m => m.CredentialingModule)
    },
    // otherwise redirect to home
    { path: '**', redirectTo: 'home' }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}